import React from 'react';
import { motion } from 'framer-motion';
import { EyeOff, Layout, Lock, BoxIcon } from 'lucide-react';
const problems = [{
  icon: BoxIcon,
  title: 'Scattered Plans',
  description: 'Travel notes spread across five apps, none of them talking to each other.'
}, {
  icon: EyeOff,
  title: 'Invisible Discoveries',
  description: 'You find incredible places but have no way to collect and revisit them.'
}, {
  icon: Layout,
  title: 'Flat, Lifeless Tools',
  description: 'Generic planners strip the wonder out of exploration.'
}, {
  icon: Lock,
  title: 'Locked-Away Geo Data',
  description: "Terrain and cartographic data exists but isn't made for travelers."
}];
export function ProblemsSection() {
  return <section className="py-24 bg-parchment-dark relative overflow-hidden" data-id="element-194">
      {/* Background Texture */}
      <div className="absolute inset-0 bg-paper-texture opacity-30" data-id="element-195" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-196">
        <div className="text-center mb-16" data-id="element-197">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-forest mb-4" data-id="element-198">
            Lost Without a Map?
          </h2>
          <div className="w-24 h-1 bg-terracotta mx-auto rounded-full" data-id="element-199" />
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-200">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} viewport={{
          once: true
        }} className={`bg-parchment p-8 rounded-sm shadow-md border border-brown/10 transform hover:-translate-y-1 transition-transform duration-300 relative group`} style={{
          transform: `rotate(${index % 2 === 0 ? '-1deg' : '1deg'})`
        }} data-id="element-201">
              {/* "Tape" effect */}
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-16 h-6 bg-yellow-100/50 rotate-1 backdrop-blur-[1px] shadow-sm" data-id="element-202" />

              <div className="w-12 h-12 bg-forest/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-forest/20 transition-colors" data-id="element-203">
                <problem.icon className="w-6 h-6 text-forest" data-id="element-204" />
              </div>

              <h3 className="text-xl font-serif font-bold text-forest mb-3" data-id="element-205">
                {problem.title}
              </h3>

              <p className="text-forest/70 font-sans leading-relaxed" data-id="element-206">
                {problem.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} viewport={{
        once: true
      }} className="mt-16 text-center max-w-3xl mx-auto" data-id="element-207">
          <p className="text-2xl font-serif italic text-forest/90 leading-relaxed" data-id="element-208">
            "Maplekeep brings it all together — your pins, your routes, your
            stories — on one beautiful, terrain-aware canvas."
          </p>
        </motion.div>
      </div>
    </section>;
}